import React, { useRef, useState } from "react";
import
{
	Box,
	Stack,
	Button,
} from "@mui/material";

import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import formService from "../../services/formService";
import SubmitModal from "../../elements/Admin/SubmitModal";

const AdditionalServicesForm = (props) =>
{
	let [showSubmitModal, setShowSubmitModal] = useState(false);
	let [sentSuccess, setSentSuccess] = useState(false);
	const [radioValues, setRadioValues] = React.useState({});
	const [error, setError] = React.useState({});
	const [helperText, setHelperText] = React.useState("Choose wisely");

	const additionalInfo = useRef(null);
	const numberLaptopsDesktops = useRef(null);
	const companyAnnualRevenue = useRef(null);
	const totalEmployees = useRef(null);
	const totalUsers = useRef(null);

	const handleRadioButtonChange = (event) =>
	{
		setRadioValues({ ...radioValues, [event.target.name]: event.target.value });
		setError({ ...error, [event.target.name]: "" });
		setHelperText("");
	};
	const handleSubmit = async (event) =>
	{
		event.preventDefault();
		setSentSuccess(false);
		setShowSubmitModal(true);
		let formValues = {
			serviceName: props.serviceName,
			additionalInfo: additionalInfo.current.value ?? "N/A",
			numberLaptopsDesktops: "N/A",
			annualRevenue: "N/A",
			totalEmployees: "N/A",
			totalUsers: "N/A",
			existingEndpointProtection: radioValues.existingEndpointProtection ?? "N/A",
			endpointProtectionType: radioValues.endpointProtectionType ?? "N/A",
			generalCyberSecurityAudit: radioValues.generalCyberSecurityAudit ?? "N/A",
			projectOrSpecificRequirement: radioValues.projectOrSpecificRequirement ?? "N/A",
			bespoke: radioValues.bespoke ?? "N/A",
			darkwebMonitoring: radioValues.darkwebMonitoring ?? "N/A",
			enterpriseSoftware: radioValues.enterpriseSoftware ?? "N/A",
			managedService: radioValues.managedService ?? "N/A",
			solutionType: radioValues.solutionType ?? "N/A",
			responseOnly: radioValues.responseOnly ?? "N/A",
			retained: radioValues.retained ?? "N/A",
		};
		switch (props.selectedService)
		{
			case "endpoint_protection":
				formValues.numberLaptopsDesktops = numberLaptopsDesktops.current.value;
				break;
			case "incident_response":
				formValues.annualRevenue = companyAnnualRevenue.current.value;
				formValues.totalEmployees = totalEmployees.current.value;
				break;
			case "phishing":
				formValues.totalUsers = totalUsers.current.value;
				break;
			case "audit":
				break;
			case "risk_monitoring":
				break;
			case "authentication":
				break;
			default:
		}
		console.log(formValues)
		await formService.additionalServices(formValues);
		setSentSuccess(true);
		setTimeout(() =>
		{
			setShowSubmitModal(false);
			props.handleClose();
		}, 1500);
	};
	const handleSubmitModalClose = () =>
	{
		setSentSuccess(false);
		setShowSubmitModal(false);
		props.handleClose();
	};

	return (
		<Box component="form" onSubmit={handleSubmit}>
			<input name="service" value={props.serviceName} type="hidden" />
			<Stack
				direction="column"
				spacing={2}
				alignItems="stretch"
				sx={{
					border: `solid 2px black`,
					borderRadius: "1.5em",
					paddingTop: "1em",
					paddingBottom: "1em",
					paddingLeft: "1.5em",
					paddingRight: "1.5em",
					margin: "0.5em",
				}}
			>
				<Stack
					direction="column"
					spacing={4}
					alignItems="stretch"
					justifyContent="center"
					sx={{ width: "100%", margin: "auto" }}
				>
					{props.selectedService === "endpoint_protection" && (
						<>
							<Stack
								direction="column"
								spacing={0}
								sx={{
									justifyContent: "space-between",
									alignItems: "stretch",
								}}
							>
								<TextField
									id="number-laptops-desktops"
									label="Total Number Of Laptops/Desktops"
									variant="outlined"
									inputRef={numberLaptopsDesktops}
								/>
							</Stack>
							<Stack
								direction="row"
								spacing={2}
								sx={{
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<FormLabel id="existing-endpoint-protection-label">
									Existing Endpoint Protection?
								</FormLabel>
								<RadioGroup
									row
									aria-labelledby="existing-endpoint-protection-label"
									name="existingEndpointProtection"
									onChange={handleRadioButtonChange}
								>
									<FormControlLabel
										value="yes"
										control={<Radio />}
										label="Yes"
									/>
									<FormControlLabel value="no" control={<Radio />} label="No" />
								</RadioGroup>
							</Stack>

							<FormControl>
								<RadioGroup
									row
									aria-labelledby="endpoint-protection-type-label"
									name="endpointProtectionType"
									onChange={handleRadioButtonChange}
								>
									<Stack
										direction="row"
										spacing={2}
										sx={{
											width: "100%",
											justifyContent: "space-evenly",
											alignItems: "center",
										}}
									>
										<FormControlLabel
											value="licence_only"
											control={<Radio />}
											label="licence only"
										/>
										<FormControlLabel
											value="managed"
											control={<Radio />}
											label="managed service"
										/>
									</Stack>
								</RadioGroup>
							</FormControl>
						</>
					)}
					{props.selectedService === "audit" && (
						<>
							<Stack
								direction="row"
								spacing={2}
								sx={{
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<FormLabel id="general-cyber-security-audit-label">
									General Cyber Security Audit
								</FormLabel>
								<RadioGroup
									row
									aria-labelledby="general-cyber-security-audit-label"
									name="generalCyberSecurityAudit"
									onChange={handleRadioButtonChange}
								>
									<FormControlLabel
										value="yes"
										control={<Radio />}
										label="Yes"
									/>
									<FormControlLabel value="no" control={<Radio />} label="No" />
								</RadioGroup>
							</Stack>
							<Stack
								direction="row"
								spacing={2}
								sx={{
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<FormLabel id="risk_monitoring-dark-web-radio-buttons-group-label">
									Project Or Specific Requirement
								</FormLabel>
								<RadioGroup
									row
									aria-labelledby="risk_monitoring-dark-web-radio-buttons-group-label"
									name="projectOrSpecificRequirement"
									onChange={handleRadioButtonChange}
								>
									<FormControlLabel
										value="yes"
										control={<Radio />}
										label="Yes"
									/>
									<FormControlLabel value="no" control={<Radio />} label="No" />
								</RadioGroup>
							</Stack>
							<Stack
								direction="row"
								spacing={2}
								sx={{
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<FormLabel id="bespoke-requirements-label">
									Bespoke (Provide Details Below)
								</FormLabel>
								<RadioGroup
									row
									aria-labelledby="bespoke-requirements-label"
									name="bespoke"
									onChange={handleRadioButtonChange}
								>
									<FormControlLabel
										value="yes"
										control={<Radio />}
										label="Yes"
									/>
									<FormControlLabel value="no" control={<Radio />} label="No" />
								</RadioGroup>
							</Stack>
						</>
					)}
					{props.selectedService === "risk_monitoring" && (
						<>
							<Stack
								direction="row"
								spacing={2}
								sx={{
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<FormLabel id="risk_monitoring-dark-web-radio-buttons-group-label">
									Dark Web Monitoring Option
								</FormLabel>
								<RadioGroup
									row
									aria-labelledby="risk_monitoring-dark-web-radio-buttons-group-label"
									name="darkwebMonitoring"
									onChange={handleRadioButtonChange}
								>
									<FormControlLabel
										value="yes"
										control={<Radio />}
										label="Yes"
									/>
									<FormControlLabel value="no" control={<Radio />} label="No" />
								</RadioGroup>
							</Stack>
							<Stack
								direction="row"
								spacing={2}
								sx={{
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<FormLabel id="enterprise-software-requirement-label">
									Enterprise Software
								</FormLabel>
								<RadioGroup
									row
									aria-labelledby="enterprise-software-requirement-label"
									name="enterpriseSoftware"
									onChange={handleRadioButtonChange}
								>
									<FormControlLabel
										value="yes"
										control={<Radio />}
										label="Yes"
									/>
									<FormControlLabel value="no" control={<Radio />} label="No" />
								</RadioGroup>
							</Stack>
							<Stack
								direction="row"
								spacing={2}
								sx={{
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<FormLabel id="managed-service-option-label">
									Managed Service Option
								</FormLabel>
								<RadioGroup
									row
									aria-labelledby="managed-service-option-label"
									name="managedService"
									onChange={handleRadioButtonChange}
								>
									<FormControlLabel
										value="yes"
										control={<Radio />}
										label="Yes"
									/>
									<FormControlLabel value="no" control={<Radio />} label="No" />
								</RadioGroup>
							</Stack>
						</>
					)}
					{props.selectedService === "authentication" && (
						<>
							<FormControl>
								<RadioGroup
									row
									aria-labelledby="endpt-prot-radio-buttons-group-label"
									name="solutionType"
									onChange={handleRadioButtonChange}
								>
									<Stack
										direction="row"
										spacing={2}
										sx={{
											width: "100%",
											justifyContent: "space-evenly",
											alignItems: "center",
										}}
									>
										<FormControlLabel
											value="FIDO2"
											control={<Radio />}
											label="Hardware solution (FIDO2)"
										/>
										<FormControlLabel
											value="software"
											control={<Radio />}
											label="Software solution"
										/>
									</Stack>
								</RadioGroup>
							</FormControl>
						</>
					)}
					{props.selectedService === "incident_response" && (
						<>
							<Stack
								direction="column"
								spacing={0}
								sx={{
									justifyContent: "space-between",
									alignItems: "stretch",
								}}
							>
								<TextField
									label="Company Total Annual Revenue"
									variant="outlined"
									inputRef={companyAnnualRevenue}
								/>
							</Stack>
							<Stack
								direction="column"
								spacing={0}
								sx={{
									justifyContent: "space-between",
									alignItems: "stretch",
								}}
							>
								<TextField
									label="Total Number Of Employees"
									variant="outlined"
									inputRef={totalEmployees}
								/>
							</Stack>

							<Stack
								direction="row"
								spacing={2}
								sx={{
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<FormLabel id="response-only-24-hour-label">
									Response Only (Within 24 Hours)
								</FormLabel>
								<RadioGroup
									row
									aria-labelledby="response-only-24-hour-label"
									name="responseOnly"
									onChange={handleRadioButtonChange}
								>
									<FormControlLabel
										value="yes"
										control={<Radio />}
										label="Yes"
									/>
									<FormControlLabel value="no" control={<Radio />} label="No" />
								</RadioGroup>
							</Stack>

							<FormControl>
								<Stack
									direction="row"
									spacing={2}
									sx={{
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<FormLabel id="incident-response-15mins-radio-buttons-group-label">
										Retained (Within 15 Minutes)
									</FormLabel>
									<RadioGroup
										row
										aria-labelledby="incident-response-15mins-radio-buttons-group-label"
										name="retained"
										onChange={handleRadioButtonChange}
									>
										<FormControlLabel
											value="yes"
											control={<Radio />}
											label="Yes"
										/>
										<FormControlLabel
											value="no"
											control={<Radio />}
											label="No"
										/>
									</RadioGroup>
								</Stack>
							</FormControl>
						</>
					)}
					{props.selectedService === "phishing" && (
						<>
							<Stack
								direction="column"
								spacing={0}
								sx={{
									justifyContent: "space-between",
									alignItems: "stretch",
								}}
							>
								<TextField
									label="Total Number Of Users For Testing"
									variant="outlined"
									inputRef={totalUsers}
								/>
							</Stack>
						</>
					)}

					<Stack
						direction="column"
						spacing={2}
						sx={{
							justifyContent: "center",
							alignItems: "stretch",
						}}
					>
						<FormControl>
							<TextField
								inputRef={additionalInfo}
								label="Any Additional Info"
								multiline
								rows={4}
							/>
						</FormControl>
					</Stack>
				</Stack>
				<Button type="submit">Submit</Button>
			</Stack>
			<SubmitModal
				open={showSubmitModal}
				sentSuccess={sentSuccess}
				onClose={handleSubmitModalClose}
			/>
		</Box>
	);
};

export default AdditionalServicesForm;
